module.exports = __webpack_public_path__ + "19d0038621e031dd46008c6b608e513d.ttf";